import {
  yesNoUI,
  yesNoSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { standardTitle } from '../../form0781/content';
import {
  evidenceChoiceIntroTitle,
  evidenceChoiceIntroDescriptionContent,
  evidenceChoiceIntroQuestion,
  ConfirmationEvidenceChoiceIntro,
} from '../content/evidenceChoiceIntroPage';

export const uiSchema = {
  'ui:title': standardTitle(evidenceChoiceIntroTitle),
  'ui:description': evidenceChoiceIntroDescriptionContent,
  'view:selectableEvidenceTypes': {
    'view:hasOtherEvidence': yesNoUI({
      title: evidenceChoiceIntroQuestion,
    }),
  },
  'ui:confirmationField': ConfirmationEvidenceChoiceIntro,
};

export const schema = {
  type: 'object',
  required: ['view:selectableEvidenceTypes'],
  properties: {
    'view:selectableEvidenceTypes': {
      type: 'object',
      required: ['view:hasOtherEvidence'],
      properties: {
        'view:hasOtherEvidence': yesNoSchema,
      },
    },
  },
};
